import React, { useEffect, useState } from 'react'

import { Outlet, useNavigate, useParams } from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import EducationalInformation from './education'
import PreceptorInformation from './preceptor'
import PersonalInformation from 'widgets/personal'

const StudentDetails = (props) => {
  const params = useParams()
  const id = params.id

  const navigate = useNavigate()

  const { firestore, functions } = useFirebase()
  const { 
    getStudent,
    student,
  } = firestore
  const { deleteProfile } = functions

  const [parents, setParents] = useState([])
  // const [preceptor, setPreceptor] = useState()

  useEffect(() => {
    getStudent(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (student === undefined) return
    setParents(student.parents !== undefined ? student.parents : [])
    // setPreceptor(student.preceptor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student])

  const [deleting, setDeleting] = useState(false)
  const onDelete = async () => {
    setDeleting(true)
    await deleteProfile({
      'uid': id,
      'role': 'student'
    })
    setDeleting(false)
    navigate(-1)
  }

  const ParentsInformation = (props) => (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={8}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>PADRES O TUTORES</b>
                </Typography>
              </Grid>
              <Grid item xs={4} align='right'>
                <IconButton size='small'><PersonAddAlt1Icon color='secondary' fontSize='small' /></IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              {
                parents.map((parent, index) => (
                  <ListItem
                    key={`parent_${index}`}
                    // secondaryAction={
                    //   <IconButton edge='end' size='small'>
                    //     <EditIcon color='lightPurple' fontSize='small' />
                    //   </IconButton>
                    // } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>{parent.name}</b>} secondary={parent.email} />
                  </ListItem>
                ))
              }
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
  
  if (student === undefined) return <Outlet />
  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Button onClick={() => navigate(-1)} size='large' startIcon={<ArrowBackIcon />}>
          <b>Volver</b>
        </Button>
      </Grid>
      <Grid item xs={12} md={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PersonalInformation collection='students' profile={student} deleting={deleting} onDelete={onDelete} />
          </Grid>
          <Grid item xs={12}>
            <EducationalInformation student={student} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={5}>
        <Grid container spacing={2}>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PreceptorInformation student={student} />
          </Grid>
          <Grid item xs={12}>
            <ParentsInformation />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default StudentDetails